$(function () {
  // スムーズスクロール
  $('a[href^="#"]').click(function () {
    var speed = 400;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("body,html").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  //スマホのみ電話リンクを付与
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
    $(".tel_link").each(function () {
      var tel = $(this);
      var html = tel.html();
      var teltext = tel.text();
      var telnum = teltext.replace(/[^0-9]/g, "");
      tel.html(
        $("<a>")
          .attr("href", "tel:" + telnum)
          .append(html)
      );
    });
  }



  // FVスライダー
    if ($(".fv_slider").length) {
    const fv_swiper = new Swiper('.fv_slider', {
        effect: 'fade',
        fadeEffect: {
        crossFade: true,
        },
        autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        },
        speed: 1000,
        loop: true,
    });
    }


  //FAQアコーディオン
  if ($(".faq").length) {
    $(".faq:not(.active) .body").hide();

    $(".faq .head").click(function () {
      const $parentFaq = $(this).closest(".faq");
      const $body = $(this).next(".body");

      if ($parentFaq.hasClass("active")) {
        $parentFaq.removeClass("active");
        $body.slideUp(400);
      } else {
        $parentFaq.addClass("active");
        $body.slideDown(400);
      }
    });
  }


});
